import { cn, Icon, Typography } from "@kyan/ui";
import React from "react";

import type { InfoGroupVariant } from "../InfoGroup.types";

const dividerContainerClassName = "flex h-4 w-full items-center";
const dividerClassName = "border-divider h-px w-full";

export interface DividerProps {
  variant: InfoGroupVariant;
  open?: boolean;
  onClick?: () => void;
}

export const Divider: React.FC<DividerProps> = ({ variant, open, onClick }) => {
  if (variant === "normal") {
    return (
      <div className={dividerContainerClassName}>
        <hr className={dividerClassName} />
      </div>
    );
  }

  return (
    <div className={cn("gap-2", dividerContainerClassName)}>
      <hr className={dividerClassName} />

      <button
        className="group flex cursor-pointer items-center gap-2"
        onClick={onClick}
      >
        <Typography
          size={12}
          className="group-hover:text-textPrimary whitespace-nowrap transition-colors"
        >
          {open ? "Show less" : "Show more"}
        </Typography>
        <Icon
          size="xs"
          name="caret-down"
          className={cn("group-hover:text-textPrimary transition-all", {
            "rotate-180": open,
          })}
        />
      </button>

      <hr className={dividerClassName} />
    </div>
  );
};
